<template>
  <d-card
    v-if="purchases && purchases.length"
    class="p-4 mb-5 order-collect-purchases">
    <h4 :class="{
      'mb-2': true,
      'd-flex': true
    }">
      <span class="d-block mr-auto">
        {{ $t('order.warehouse.purchases.title') }}
      </span>
    </h4>

    <table
      :style="'opacity: ' + (loadingPurchases ? '0.35' : '1') + ';'"
      class="table mt-2">
      <thead>
        <tr>
          <th>{{ $t('order.warehouse.purchases.orderName') }}</th>
          <th style="width: 200px;">{{ $t('status.status') }}</th>
          <th style="width: 240px;">{{ $t('ui.subSupplier') }}</th>
          <th style="width: 240px;">{{ $t('ui.supplier') }}</th>
          <th style="width: 240px;">{{ $t('ui.actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(purchase, index) of purchases"
          :key="'related-purchase-' + index">
          <td class="align-middle">
            #{{ purchase.id }} {{ purchase.order_name }}
          </td>
          <td class="align-middle">
            <d-badge
              v-if="purchase.status === 'NEW'"
              theme="primary">
              {{ $t('purchase.newOrder') }}
            </d-badge>
            <d-badge
              v-if="purchase.status === 'WAITING_PAYMENT'"
              theme="warning">
              {{ $t('order.pendingPayment') }}
            </d-badge>
            <d-badge
              v-if="purchase.status === 'WAITING_PRODUCTS'"
              theme="warning">
              {{ $t('order.waitingPurchaseProducts') }}
            </d-badge>
            <d-badge
              v-if="purchase.status === 'CLOSED'"
              theme="danger">
              {{ $t('purchase.closed') }}
            </d-badge>
            <d-badge
              v-if="!purchase.status"
              theme="light">
              {{ $t('ui.lack') }}
            </d-badge>
          </td>
          <td class="align-middle">
            <small>
              {{ purchase.sub_customer_name }}<br>
              {{ $t('order.warehouse.purchases.received') }}:
              <template v-if="purchase.suborder_received_at">{{ purchase.suborder_received_at }}</template>
              <template v-else>&mdash;</template>
            </small>
          </td>
          <td class="align-middle">
            <small>
              {{ purchase.customer_name }}<br>
              {{ $t('order.warehouse.purchases.received') }}:
              <template v-if="purchase.received_at">{{ purchase.received_at }}</template>
              <template v-else>&mdash;</template>
            </small>
          </td>
          <td class="align-middle">
            <d-button
              v-if="purchase.sub_customer_id && !purchase.suborder_received_at"
              theme="success"
              :disabled="purchaseReceiveInProgress"
              @click.prevent="receivePurchase(purchase.id, purchase.sub_customer_id)">
              <div
                v-if="purchaseReceiveInProgress"
                class="spinner-border spinner-border-sm"
                role="status"></div>
              {{ $t('order.warehouse.purchases.receivedFromSubSupplier') }}
            </d-button>
            <d-button
              v-else-if="purchase.customer_id && !purchase.received_at"
              theme="success"
              :disabled="purchaseReceiveInProgress"
              @click.prevent="receivePurchase(purchase.id, purchase.customer_id)">
              <div
                v-if="purchaseReceiveInProgress"
                class="spinner-border spinner-border-sm"
                role="status"></div>
              {{ $t('order.warehouse.purchases.receivedFromSupplier') }}
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>
  </d-card>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'order-collect-purchases',
  props: [
    'purchases'
  ],
  data () {
    return {
      loadingPurchases: false,
      purchaseReceiveInProgress: false
    }
  },
  mounted () {
    Vue.nextTick(() => {
      this.$bus.$emit('order-collect-purchases-reload-needed');
    });

    this.$bus.$on('order-collect-loading-purchases', this.setLoadingPurchases);
  },
  methods: {
    receivePurchase (purchaseID, customerID) {
      this.purchaseReceiveInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/purchases/confirm-receive/' + purchaseID,
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('notifications.markingFailedTryAgain'),
        formData: {
          customer_id: customerID
        },
        successAction: () => {
          this.purchaseReceiveInProgress = false;
          this.$bus.$emit('order-collect-purchases-reload-needed');
        },
        failAction: () => {
          this.purchaseReceiveInProgress = false;
        }
      });
    },
    setLoadingPurchases (newState) {
      this.loadingPurchases = newState;
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-collect-loading-purchases', this.setLoadingPurchases);
    this.$bus.$off('order-collect-loading-purchases', this.setLoadingPurchases);
  }
};
</script>
